export const text = {
  RESCHEDULING_UNAVAILABLE: 'Rescheduling unavailable',
  RESCHEDULE_VISIT: 'Reschedule visit',
  ADDITIONAL_PAYMENT_REASON: 'Additional payment is required',
  PROVIDER_NOT_LICENSED_REASON: 'Provider not licensed in booking state',
  IN_PROGRESS_STATUS: 'inprogress',
  IN_WAITING_ROOM_BACK: 'inwaitingroomback',
  IN_WAITING_ROOM_BACK_STATUS: 'In waiting room back',
  IN_PROGRESS_REASON: 'Visit already started',
}
